import type { Schema } from "./api";

export type DocumentDelivery = Schema["DocumentDeliveryOut"];
export const unassignedDocument = "unassigned";

export function documentWorks<T extends { id: string }>(rows: T[], plan: DocumentDelivery | undefined, documentId: string): T[] {
  if (!documentId) return rows;
  const ids = new Set(documentId === unassignedDocument ? plan?.unassigned_ids :
    plan?.documents.find(document => document.document_id === documentId)?.work_ids);
  return rows.filter(row => ids.has(row.id));
}

export function documentNote(plan: DocumentDelivery | undefined, documentId: string): string {
  if (documentId === unassignedDocument) return "Эти работы сохранены один раз. Основной PDF не определён; объёмы по документам не распределены.";
  return plan?.documents.find(document => document.document_id === documentId)?.note || "";
}
